<template>
  <footer>
    <div class="container">
      <FooterInfo v-if="configs[$parent.site].titulo === 'Le Lis Blanc'"/>
      <div class="footer-inner">
        <div class="footer-links">
          <div v-for="(link,index) in configs[$parent.site]['footer-links']" :key="index">
            <h4>{{link.nome}}</h4>
            <ul>
              <li
                v-for="(sub,subindex) in configs[$parent.site]['footer-links'][index].submenu"
                :key="subindex"
              >
                <a :href="sub.url" target="_blank">{{sub.nome}}</a>
              </li>
            </ul>
          </div>
          <div>
            <h4>SIGA-NOS</h4>
            <div class="social-networks">
              <a
                v-for="(social,index) in configs[$parent.site]['social-networks']"
                :key="index"
                :href="social.url"
                :title="social.nome"
                target="_blank"
              >
                <img :src="getImage(social.img)" :alt="social.nome" />
              </a>
            </div>

            <h4>FORMAS DE PAGAMENTO</h4>
            <img
              :src="getImage('cartoes.png')"
              alt="Formas de Pagamento"
              title="Formas de Pagamento"
            />
          </div>
        </div>
      </div>
      
    </div>
    <div class="seals">
      <img :src="getImage('eureciclo.png')"
      alt="Eu Reciclo"
      title="Eu Reciclo"
      />
      <img :src="getImage('thefashionpact.png')"
      alt="The Fashion Pact"
      title="The Fashion Pact"
      />
    </div>
    <div class="copyright">
      <div class="container" v-html="configs[$parent.site].copyright">

      </div>
    </div>
  </footer>
</template>
<style lang="scss">
footer {
  background-color: #ffffff;
  margin-top: 50px;
}
.footer-inner .footer-links li,
.footer-inner .footer-links a {
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  font-size: 13px;
  text-decoration: none;
}
.footer-inner .footer-links {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-self: flex-start;
  justify-content: space-between;
  padding: 30px 0;
}
.footer-inner .footer-links a:hover {
  text-decoration: underline;
}
.footer-inner .footer-links h4 {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  text-transform: uppercase;
}
.seals {
    padding-top: 24px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 36px
}

.copyright {
  text-align: center;
  width: 100%;
  padding: 30px 0;
  color: #999;
  font-size: 11px;
}
.footer-inner .footer-links > div:not(:last-child) {
  margin-right: 50px;
}
.footer-inner {
  width: 90%;
  max-width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-inner .footer-links li {
  padding: 2px 0;
}
.footer-inner .footer-links > div {
  height: 170px;
}
.copyright li {
  font-weight: 400;
  color: #999;
  font-size: 11px;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-networks {
  & img {
    margin: 6px 24px 48px 0;
    &:hover,
    &:active {
      text-decoration: none;
      filter: brightness(0);
    }
  }
}
@media (max-width: 1135px) {
  .footer-inner .footer-links {
    width: 100%;
  }
}
@media (max-width: 911px) {
  .footer-inner .footer-links > div:last-child {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
}
/* Breakpoint mobile */

@media (max-width: 560px) {
  .footer-inner .footer-links > div:not(:last-child) {
    margin: 0 0 30px 0;
  }
  .footer-inner .footer-links > div {
    width: 100%;
    height: auto;
    text-align: center;
  }
  .copyright > ul {
    padding: 5px 30px;
  }
}
</style>
<script>
import { configs } from "@/assets/data/data.json";
import FooterInfo from "@/components/FooterInfo";

export default {
  name: "Footer",
   components: {
    FooterInfo
  },
  data() {
    return {
      configs
    };
  },
  methods: {
    getImage(image) {
      const icons = require.context(
        "../assets/",
        true,
        /\.(png|jpe?g|gif|svg)(\?.*)?$/
      );
      return image ? icons(`./${this.$parent.site}/${image}`) : "";
    }
  }
};
</script>